export default __webpack_public_path__ + "static/media/collagen-drinking@3x.b7e791c1.jpg";